export class Controller {

    /** @ngInject */
    constructor($state, Alert, DirectoriesResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    $onInit() {
    }

    save(name) {
        return this.DirectoriesResource
            .updateDirectory(this.companyId, {...this.directory, name})
            .then(() => {
                this.Alert('success', 'company.directory-integration.manage.main.updated', {directoryTypeName: this.directory.typeName});
                this.$state.reload('company.directory-integration');
            });
    }

}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/main/directory-manage-main.controller.js